import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

const STORAGE_KEY = 'clientelo_chunk_reload_once';

function isChunkLoadError(e: unknown): boolean {
  const name = e && typeof e === 'object' && 'name' in e ? String((e as { name: string }).name) : '';
  const message = e instanceof Error ? e.message : String(e);
  return (
    name === 'ChunkLoadError' ||
    message.includes('Loading chunk') ||
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed')
  );
}

/**
 * Igual que React.lazy, pero si falla la carga del chunk (típico tras HMR o nuevo build
 * con el bundle viejo en caché), recarga la página una sola vez.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
): LazyExoticComponent<T> {
  return lazy(async () => {
    try {
      const mod = await factory();
      sessionStorage.removeItem(STORAGE_KEY);
      return mod;
    } catch (e: unknown) {
      if (isChunkLoadError(e) && !sessionStorage.getItem(STORAGE_KEY)) {
        sessionStorage.setItem(STORAGE_KEY, '1');
        window.location.reload();
        // La pestaña se recarga; esta promesa no debe resolverse en la práctica.
        return new Promise<never>(() => {});
      }
      throw e;
    }
  }) as LazyExoticComponent<T>;
}
